import "./form.css";
import background_img from "./../../static/images/fundo_amarelo.jpg";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionTypes } from './../../store';
import {  base64ToFile} from "../../validations.js";
import {useNavigate} from "react-router-dom";
import axios from "axios";
import AppRoutes from "./../../routes.js";
import Load from './../load/load.js';
import Dots from "./../dots/dots.js";
import TCLE from './../pages/TCLE.js';
import HereditaryRisk from './../pages/hereditaryRisk.js';
import Exoma from './../pages/exoma.js';
import MicroArray from './../pages/microArray.js';
import PageSeven from './../pages/pageSeven.js';//TODO REVER O MODO QUE É CHAMADO
import backgroundImg from '../../static/images/background_1.webp';

export default function Form() {
    const dispatch = useDispatch();
    let navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(useSelector((state) => state.page));
    const data = useSelector((state) => state.data);
    const file = base64ToFile(useSelector((state) => state.doc_image))
    const [load, setLoad] = useState(false);
    const pages = getPages(data)

    const states=[
    { id: '', name: 'Selecione...' },
    { id: 'AC', name: 'Acre' },
    { id: 'AL', name: 'Alagoas' },
    { id: 'AP', name: 'Amapá' },
    { id: 'AM', name: 'Amazonas' },
    { id: 'BA', name: 'Bahia' },
    { id: 'CE', name: 'Ceará' },
    { id: 'DF', name: 'Distrito Federal' },
    { id: 'ES', name: 'Espírito Santo' },
    { id: 'GO', name: 'Goiás' },
    { id: 'MA', name: 'Maranhão' },
    { id: 'MT', name: 'Mato Grosso' },
    { id: 'MS', name: 'Mato Grosso do Sul' },
    { id: 'MG', name: 'Minas Gerais' },
    { id: 'PA', name: 'Pará' },
    { id: 'PB', name: 'Paraíba' },
    { id: 'PR', name: 'Paraná' },
    { id: 'PE', name: 'Pernambuco' },
    { id: 'PI', name: 'Piauí' },
    { id: 'RJ', name: 'Rio de Janeiro' },
    { id: 'RN', name: 'Rio Grande do Norte' },
    { id: 'RS', name: 'Rio Grande do Sul' },
    { id: 'RO', name: 'Rondônia' },
    { id: 'RR', name: 'Roraima' },
    { id: 'SC', name: 'Santa Catarina' },
    { id: 'SP', name: 'São Paulo' },
    { id: 'SE', name: 'Sergipe' },
    { id: 'TO', name: 'Tocantins' }
    ]
    dispatch({type:actionTypes.set_states, payload:states}) //TODO MOVER DEPOIS


    function getPages(d){
        var hereditaryList = [108937,108959,108957,109151]
        if (d?.products?.includes(109071)){
            return [TCLE]
        }
        else if(d?.products?.includes(109061)) {//TODO
            return [TCLE,MicroArray]
        }
        else if(d?.products?.includes(109139)) {//TODO
            return [TCLE]
        }
        else if(d?.products?.includes(109151)) {//TODO
            return [TCLE]
        }
        else if(d?.products?.includes(108995)){
            return [TCLE,Exoma]
        }
        else if(d?.products?.some((p) => hereditaryList.includes(p))){//TODO
            return [TCLE,HereditaryRisk]
        }
        else{
            alert("Jogar p pagina final e avisar de erro")
            navigate(AppRoutes.finish)
        }

    }
    const getCurrentDateAndTimeInBrazil = () => {
        const optionsDate = {
            timeZone: 'America/Sao_Paulo',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        };
        const optionsTime = {
            timeZone: 'America/Sao_Paulo',
            hour: '2-digit',
            minute: '2-digit'
        };
        const now = new Date();
        const date = new Intl.DateTimeFormat('pt-BR', optionsDate).format(now);
        const time = new Intl.DateTimeFormat('pt-BR', optionsTime).format(now);
        return [date, time];
    };
    async function finish(falseImage = false){
        try {
            setLoad(true);
            var [currentDate, currentHour] = getCurrentDateAndTimeInBrazil();
            console.log("Backend URL:", AppRoutes.backend);
            const header = {'Content-Type':'application/json', 'Authorization': `Basic ${data.token}`}
             const jsonData = JSON.stringify({...data, 'TCLE':{...data.TCLE, "data_atual": currentDate,
                "hora_atual":currentHour}});
            console.log(jsonData)
            const response = await axios.post(`${AppRoutes.backend}post_data`, jsonData,
                { headers: header });
            console.log("Resposta recebida do endpoint '/post_data':", response.data);
            dispatch({type:actionTypes.set_finish, payload:response.data})
            navigate(AppRoutes.sign)
            setLoad(false);
        } catch (error) {
            if(error?.message?.includes('ERR_FAILED 413') && falseImage === false){
                finish(true);
            }
            dispatch({type:actionTypes.set_errors, payload:error.toString()})
            navigate(AppRoutes.finish)
            setLoad(false);
        }
    }

    function changePage(event){
        if(event === "finish"){
            finish()
            console.log('finish')
        }
        else{
            console.log(event)
            setCurrentPage((i) => event === "next"?(i+1):(i-1));
        }
    }

    function setPage(page){
        if (load){
            return (<div className="w-100 d-flex justify-content-center flex-grow-1">
                        <div className="d-flex  justify-content-center flex-column ">
                            <Load message="Aguarde para Assinar"/>
                        </div>
                    </div>);
        }
        else{
            dispatch({ type: actionTypes.set_page, payload: page });  //atalho para página 3
            const PageComponent = pages[page];
            if (PageComponent) {
                return <PageComponent changePage={changePage} />;
            } else {
                navigate(AppRoutes.finish)
            }
        }
    };
    useEffect(() => {
        if (!data?.deal_bitrix){
            navigate("/");
        }
    },[data])
    useEffect(() => {
        console.log(currentPage)
        console.log(pages?.length - 1)
    },[currentPage])
    if (data?.deal_bitrix){
        return (
            <div className="form" style={{backgroundImage: `url(${background_img})`}}>
                <div className="container">
                    <Dots active={currentPage} qtd={pages?.length}/>
                    <div className="base">
                        <div className="content">
                            {pages && setPage(currentPage)}
                        </div>
                        <div className="row g-0 justify-content-between">
                            {currentPage > 0 && !load?(
                                <button className="backButton" name="back" type="submit" form={`form${currentPage+1}`}>Voltar</button>):
                                (<div className="spaceButton"></div>)}

                            { currentPage > 0 && !load && currentPage < (pages?.length - 1)&&
                                <button className="nextButton" name="next" type="submit" form={`form${currentPage+1}`}>Próximo</button>}

                            {currentPage === 0 && !load && <button name="next" className="nextButton" type="submit" form={`form${currentPage+1}`}>Próximo</button>}
                            {currentPage === (pages?.length - 1) && !load && <button name="finish" className="nextButton" type="submit" form={`form${currentPage+1}`}>Finalizar</button>}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    else{
        return(<></>)
    }
}
